import { styled } from '@mui/material/styles';

export const CardRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'default' | 'primary' }>(({ theme, variant }) => ({
  background: variant === 'primary' ? theme.palette.ternary.main : theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '16px 12px',
  textAlign: 'center',
  boxShadow: variant === 'primary' ? theme.shadows[10] : theme.shadows[3],
  borderRadius: theme.shape.borderRadius,
  marginBottom: 16,
  width: '100%',
  boxSizing: 'border-box',
}));
